import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { RouterProvider } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { queryClient } from "./lib/queryClient";
import { router } from "./router";
import { GlobalErrorFallback } from "./components/GlobalErrorFallback";
import { useBranding } from "./hooks/useBranding";

/**
 * index.html cannot read the API, so its <title> carries the neutral default
 * and the real product name is applied once GET /api/config resolves.
 */
function DocumentTitle() {
  const { productName } = useBranding();
  if (typeof document !== "undefined" && document.title !== productName) {
    document.title = productName;
  }
  return null;
}

export function App() {
  return (
    <ErrorBoundary FallbackComponent={GlobalErrorFallback}>
      <QueryClientProvider client={queryClient}>
        <DocumentTitle />
        <RouterProvider router={router} />
        {import.meta.env.DEV && <ReactQueryDevtools buttonPosition="bottom-left" />}
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
